commonModule.factory('providerFeaturesService', ['$http', '$q', 'AppSettings', 'userAuthenticateService', 'commonRESTCallService', 'imSessionVarsService', 'erateSessionVarsService',
    function ($http, $q, AppSettings, userAuthenticateService, commonRESTCallService, imSessionVarsService, erateSessionVarsService) {
        var featuresApi = {};

        featuresApi.getProviderApplicationSettings = function() {
            var options  = { applicationName: "TailLightCommerce"};
            return privateGetProviderApplicationSettings(options);
        };

        featuresApi.getProviderApplicationSetting = function(settingKey, defaultValue) {
            var options  = { applicationName: "TailLightCommerce", settingKey: settingKey };
            if (arguments.length > 1) {  // differentiates no default passed from undefined passed as default
                options.defaultValue = defaultValue;
            }
            return privateGetProviderApplicationSetting(options);
        };

        featuresApi.getFeatureMetadata = function(strategy, featureName, defaultValue) {
            // default value is optional -
            var options  = { applicationName: "SPAN", settingKey: composeKey(strategy, featureName) };
            if (arguments.length > 2) { // differentiates no default passed from undefined passed as default
                options.defaultValue = defaultValue;
            }
            return privateGetProviderApplicationSetting(options);
        };

        function composeKey(strategy, featureName) {
            return strategy + '-' + featureName;
        }

        featuresApi.getFeatureData = function(datasource, featureName, defaultValue) {
            var promiseWrapper = $q.defer();
            // data source should be a name, which is mapped to a url endpoint
            var endpoint = detokenizeDatasource(datasource, featureName);

            commonRESTCallService.getFromServer(endpoint)
                .success(function(responseData) {
                    var data = angular.fromJson(responseData);
                    promiseWrapper.resolve(data);
                }, function(error) {
                    promiseWrapper.reject(error);
                });

            return promiseWrapper.promise;
        };

        function detokenizeDatasource(datasource, featureName) {
            var dataUrl = datasource.replace('{tlc-api}', AppSettings.startSPANPlusSvcURL);
            dataUrl = dataUrl.replace('{provider-code}', imSessionVarsService.getCurrentProviderCode());
            dataUrl = dataUrl.replace('{dealer-id}', erateSessionVarsService.getCurrentDealerSPANId());
            dataUrl = dataUrl.replace('{field-name}', featureName);

            return dataUrl;
        }

        // KRE - This retrieves all application Settings per provider - provider & dealership based, we can modify this in the future to separate the provider & dealership settings
        function privateGetProviderApplicationSettings(options) {
            var promiseWrapper = $q.defer();

            var prov = imSessionVarsService.getCurrentProviderId();
            if (prov === "ABCDEFGHIJKLMNOPQRSTUVWXYZ"){
                promiseWrapper.resolve(options.defaultValue);//no provider? don't make the call
            } else {
            var url = AppSettings.startIdentitySvcURL + 'applicationsettings/application/' + options.applicationName + '/provider/' + prov;

            commonRESTCallService.getFromServerWithToken(
                url, userAuthenticateService.getUserToken()
            ).success(function(responseData) {
                var found =  _.filter(responseData, function(element) {  return element.SettingType === 'ProviderBased'; });
                if (found) {
                    // note: defaultValue could exist as property, but have value of undefined
                    promiseWrapper.resolve(found);
                } else {
                    // There was no kv pair for this feature on this provider, and no default was given either
                    promiseWrapper.reject('No settings found for this provider.');
                }
            }).error(function(responseData) {
                promiseWrapper.reject(responseData);
            });
            }
            return promiseWrapper.promise;
        }

        function privateGetProviderApplicationSetting(options) {
            var promiseWrapper = $q.defer();

            var prov = imSessionVarsService.getCurrentProviderId();
            if (prov === "ABCDEFGHIJKLMNOPQRSTUVWXYZ"){
                promiseWrapper.resolve(options.defaultValue);//no provider? don't make the call
            } else {
            var url = AppSettings.startIdentitySvcURL + 'applicationsettings/application/' + options.applicationName + '/provider/' + prov;

            commonRESTCallService.getFromServerWithToken(
                url, userAuthenticateService.getUserToken()
            ).success(function(responseData) {
                var found =  _.find(responseData, function(element) {  return element.SettingKey === options.settingKey; });
                if (found || options.hasOwnProperty('defaultValue')) {
                       promiseWrapper.resolve(found ? found.SettingValue : options.defaultValue);
                } else {
                    // There was no kv pair for this feature on this provider, and no default was given either
                    promiseWrapper.reject('No metadata found for the ' + options.settingKey + ' feature.');
                }
            }).error(function(responseData) {
                promiseWrapper.reject(responseData);
            });
            }
            return promiseWrapper.promise;
        }

        featuresApi.profitSettingMode = null;

        featuresApi.getProviderProfitSettingMode = function() {
            var returnValPromise = $q.defer();
    
            if (featuresApi.profitSettingMode){
                returnValPromise.resolve(featuresApi.profitSettingMode);
            }
            // The business services end point:
            //"GetProfitSetting/{applicationPartnerCode}/{dealerProviderCode}/{profileDate}/{productCode}",
            var getUrl = AppSettings.startSPANDealerSettingsURL + '/GetProfitSettingMode/' + imSessionVarsService.getCurrentProviderCode() ;
    
            commonRESTCallService.getFromServer(getUrl)
                .success(function(responseData, status) {
                   
                    featuresApi.profitSettingMode = responseData.Mode;
    
                    returnValPromise.resolve(responseData.Mode);
                })
                .error(function(responseData, status) {
                    returnValPromise.reject("Error retrieving profit setting");
                });
    
            return returnValPromise.promise;
        };
    
        return featuresApi;
    }
]);